import {createFormActionTypes} from "../../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../../shared/ts/helpers/create_form_actions";

export const NATIVES_FILTER_PREFIX = "natives/filter_list";
export const filterNativeListFormTypes = createFormActionTypes(NATIVES_FILTER_PREFIX);
export const filterNativeListFormActions = createFormActions(filterNativeListFormTypes);
